import ScrollCinematicExperience from './ScrollCinematicExperience';

/**
 * HeroSection — Now wraps the ScrollCinematicExperience
 * 
 * The previous static hero with background image has been replaced
 * by a scroll-driven cinematic video experience that integrates
 * both the Hero and About content into one continuous sequence.
 * 
 * The typewriterText prop is accepted but not used, to maintain
 * compatibility with App.js without requiring changes there.
 */
const HeroSection = ({ typewriterText }) => {
  return (
    <section id="hero" aria-label="Experiencia cinematográfica principal">
      <ScrollCinematicExperience />
    </section>
  );
};

export default HeroSection;
